import { render, staticRenderFns } from "./AreaOrProviderSelector.vue?vue&type=template&id=e59236b0&scoped=true&"
import script from "./AreaOrProviderSelector.vue?vue&type=script&lang=js&"
export * from "./AreaOrProviderSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59236b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
